const runMethods = (methods, delayMs = 80) => {
  methods.forEach((method, index) => {
    window.setTimeout(() => {
      try {
        method();
      } catch {
        /* try next bridge */
      }
    }, index * delayMs);
  });
};

async function clearRuntimeCaches() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    /* ignore */
  }
  try {
    const regs = await navigator.serviceWorker?.getRegistrations?.();
    if (regs) {
      await Promise.all(regs.map((reg) => reg.unregister()));
    }
  } catch {
    /* ignore */
  }
}

/** Close / exit the kiosk shell (Android WebView, kioskAPI, PWA). */
export function closeApp() {
  const win = window;

  void clearRuntimeCaches();

  runMethods([
    () => win.kioskAPI?.close?.(),
    () => win.kioskAPI?.systemExit?.(),
    () => win.kioskAPI?.exitApp?.(),
    () => win.kioskAPI?.exit?.(),
    () => win.kioskAPI?.quit?.(),
    () => win.Android?.finish?.(),
    () => win.Android?.finishAffinity?.(),
    () => win.Android?.exitApp?.(),
    () => win.Android?.closeApp?.(),
    () => win.Android?.exitKiosk?.(),
    () => win.navigator?.app?.exitApp?.(),
    () => win.electronAPI?.close?.(),
    () => win.electronAPI?.quit?.(),
    () => win.close(),
    () => {
      win.location.href = "about:blank";
    },
  ]);
}
